module.exports = __webpack_public_path__ + "static/media/hangman4.048acbf2.png";